import PropTypes from 'prop-types';
import SiteHistory from './components/SiteHistory';
import ReimbursementDue from './components/ReimbursementDue';
import EnergyUsage from './components/EnergyUsage'
import ProfitShareUtilisation from './components/ProfitShareUtilisation'

const FfPsDno = ({statement}) => {

  const reimbursementDue = 0;

  return (
    <div>
      <SiteHistory siteLiveDate={statement.data.siteLiveDate} liveDaysInQ={statement.data.liveDaysInQ}/>
      <EnergyUsage data={statement.data}/>
      <ProfitShareUtilisation data={statement.data} />
      
      {/* get clarification from leo */}
      <ReimbursementDue reimbursementDue={reimbursementDue}/>
    </div>
  )
}

export default FfPsDno;

FfPsDno.propTypes = {
  statement: PropTypes.object.isRequired,
};